<!-- Loading -->
<ng-container *ngIf="!ready">
  <div class="rc-loading">
    <div class="rc-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">

  <!-- Header -->
  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap">
        <mat-icon>business</mat-icon>
      </div>
      <div>
        <span>{{ uid ? 'Editar empresa relacionada' : 'Nueva empresa relacionada' }}</span>
        <small class="dlg-hdr__sub" *ngIf="uid">Modifica los datos de la empresa</small>
        <small class="dlg-hdr__sub" *ngIf="!uid">Completa los datos para añadir la empresa</small>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="rc-body">
    <div class="row g-3">

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre o Razón Social</mat-label>
          <mat-icon matPrefix>business</mat-icon>
          <input type="text" matInput required
            name="relatedCompaniesModel.nameOrBusinessName"
            [formControl]="nameOrBusinessNameFormControl"
            [(ngModel)]="relatedCompaniesModel.nameOrBusinessName"
            placeholder="Ej: Empresa ABC, S.L.">
          <mat-error *ngIf="nameOrBusinessNameFormControl.hasError('required')">
            El nombre es obligatorio
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de cuenta corriente</mat-label>
          <mat-icon matPrefix>account_balance</mat-icon>
          <mat-select [(ngModel)]="relatedCompaniesModel.accountsTypeGroup"
            [formControl]="accountsTypeGroupFormControl" required>
            <mat-option disabled value=""><em>Seleccionar tipo</em></mat-option>
            <mat-option *ngFor="let opt of accountsTypeGroup_options" [value]="opt.id">
              {{ opt.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="accountsTypeGroupFormControl.hasError('required')">
            El tipo de cuenta es obligatorio
          </mat-error>
        </mat-form-field>
      </div>

    </div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions align="end" class="dlg-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">
      Cancelar
    </button>
    <button mat-flat-button color="primary" class="rc-btn-save" type="button" (click)="onSubmit()" [disabled]="submitted">
      <mat-icon>save</mat-icon>
      {{ uid ? 'Guardar cambios' : 'Crear empresa' }}
    </button>
  </mat-dialog-actions>

</ng-container>
